import { queryTag as queryTagHttp } from '@wix/ambassador-prime-auto-v1-tag/http';
import type {
  QueryTagRequest,
  QueryTagResponse,
} from '@wix/ambassador-prime-auto-v1-tag/types';

import type { Essentials } from '../../../models';
import { isSSR } from '../../../utils/is-ssr';

export type Category = {
  slug: string;
  name: string;
  description: string;
  image: string;
  subCategoriesIds: string[];
};

export async function getCategory({
  httpClient,
  rpcClient,
  slug,
  languageCode,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient: Essentials['rpcClient'];
  slug: string;
  languageCode: string;
}): Promise<Category> {
  const queryTagResponse = await queryTag({
    httpClient,
    rpcClient,
    slug,
    languageCode,
  });

  const { tags } = queryTagResponse;
  const category = tags?.[0];

  return {
    slug: category?.slug ?? '',
    name: category?.content?.name ?? category?.name ?? '',
    description: category?.content?.description ?? category?.description ?? '',
    image: category?.assetsMap?.collectionImage?.assets?.[0].url ?? '',
    subCategoriesIds: category?.subcategoryIds ?? [],
  };
}

async function queryTag({
  httpClient,
  rpcClient,
  slug,
  languageCode,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient: Essentials['rpcClient'];
  slug: string;
  languageCode: string;
}): Promise<QueryTagResponse> {
  const queryTagRequest: QueryTagRequest = {
    query: {
      filter: {
        slug,
      },
    },
    languageCode,
  };

  if (isSSR() && rpcClient !== undefined) {
    const queryTagRpc = (await import('@wix/ambassador-prime-auto-v1-tag/rpc'))
      .queryTag;
    return rpcClient.request(queryTagRpc(queryTagRequest));
  }

  const { data: queryTagResponse } = await httpClient.request(
    queryTagHttp(queryTagRequest),
  );

  return queryTagResponse;
}
